const GITHUB_UPLOAD_REPO = "https://api.github.com/repos/zjoanert"

export const githubBesturing = {
    getFoto: (id: string) => {
        return new Promise<Blob>((resolve, reject) => {
            const xml = new XMLHttpRequest()
            xml.addEventListener("loadend", () => {
                if (xml.status === 200 || xml.status === 302) {
                    resolve(xml.response)
                } else {
                    reject()
                }
            })
            xml.open("GET", `${GITHUB_UPLOAD_REPO}/${localStorage.getItem("album")}/contents/${id}`)
            xml.setRequestHeader("Authorization", `Bearer github_pat_${localStorage.getItem("token")}`)
            xml.setRequestHeader("Accept", "application/vnd.github.raw")
            xml.responseType = "blob"
            xml.send()
        })
    },
}
